export default function ArrowLeftIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" viewBox="0 0 24 24" {...props}>
      <path d="M21.4 11H6.8l5.3-5.3-1.4-1.4L3 12l7.7 7.7 1.4-1.4-5.3-5.3H21.4v-2z" fill="currentColor" />
    </svg>
  );
}
